import React, { VFC } from 'react';
import Grid from '@material-ui/core/Grid';
import FlightIcon from '@material-ui/icons/Flight';

import { anaBackgroundColor, anaBlue } from '../Ana';
import Title from '../Title';
import { styles as containerStyles } from '../../styles/container';
// anti pattern
import Card from '../../../front/Businesses/Card';
import { makeStyles } from '@material-ui/core/styles';

interface Props {
  isAuthenticated: boolean;
  businessesGroupedByAirport: { airportName: string; businesses: any[] }[];
}
const Businesses: VFC<Props> = ({
  isAuthenticated,
  businessesGroupedByAirport,
}: Props) => {
  const {
    root,
    wrapper,
    businessesWrapper,
    airportTitle,
    flightIcon,
    airportNameStyle,
    businessContainer,
  } = useStyles();
  return (
    <div className={root}>
      <div className={wrapper}>
        <Title texts={['おてつたび先一覧']} />
        {businessesGroupedByAirport.map(
          ({ airportName, businesses }) =>
            businesses.length > 0 && (
              <div key={airportName} className={businessesWrapper}>
                <h3 className={airportTitle}>
                  <FlightIcon className={flightIcon} />
                  <span className={airportNameStyle}>{airportName}</span>
                </h3>
                <Grid container spacing={2} className={businessContainer}>
                  {businesses.map((business) => (
                    <Grid item xs={6} sm={3} key={business.id}>
                      <Card {...business} isAuthenticated={isAuthenticated} />
                    </Grid>
                  ))}
                </Grid>
              </div>
            ),
        )}
      </div>
    </div>
  );
};

export default Businesses;

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: anaBackgroundColor,
  },
  wrapper: {
    width: '100%',
    maxWidth: theme.breakpoints.values.lg,
    margin: 'auto',
    ...containerStyles(theme),
  },
  businessesWrapper: {
    marginBottom: theme.spacing(4),
  },
  airportTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: -4,

    marginTop: 20,
    [theme.breakpoints.up('md')]: {
      marginTop: 0,
    },
  },
  flightIcon: {
    color: anaBlue,
    marginRight: 8,
  },
  airportNameStyle: {
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(18),
    margin: theme.spacing(2, 0),
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(24),
      margin: theme.spacing(0),
    },
  },
  businessContainer: {
    paddingTop: theme.spacing(2.5),
  },
}));
